import React, { useEffect, useState } from "react";
// import Logo from "../../../assets/Credin Logo (1).svg";
import "./AddLead.css";
import { TextField, MenuItem } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AiOutlineTable } from "react-icons/ai";
import axios from "axios";
import { useNavigate } from "react-router";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../../../Sidebar/Sidebar";
// import { Link } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { url } from "../../../App";
import Cookies from 'js-cookie';

export default function AddLead() {
  const [open, setOpen] = React.useState(false);

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  // const [leads, setLeads] = useState([]);

  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);

  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [leadEmail, setLeadEmail] = useState("");
  // const [pan, setPan] = useState("");
  // const [aadhaar, setAadhaar] = useState("");
  const [voterId, setVoterId] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [source, setSource] = useState("");
  const [otpVerification, setOtpVerification] = useState(false);
  const [borrowerOtp, setBorrowerOtp] = useState("");
  const [connectorData, setConnectorData] = useState([]);
  const [connector, setconnector] = useState("");
  // const [creditScore,setCreditScore] = useState("");
  // const [leadStatus, setLeadStatus] = useState("Rejected");

  const [companyIdSuperadmin, setCompanyIdSuperadmin] = useState("");
  const [branchIdSuperadmin, setBranchIdSuperadmin] = useState("");

  const [panNo, setPanNo] = useState("");
  const [panDump, setPanDump] = useState("");
  const [panValidation, setPanValidation] = useState("Yet to Verify");
  const [panAadhaarLink, setPanAadhaarLink] = useState("");
  const [aadhaarNo, setAadhaarNo] = useState("");
  const [aadhaarDump, setAadhaarDump] = useState("");
  const [aadhaarValidation, setAadhaarValidation] = useState("Yet to Verify");
  const [aadhaarLinkStatus, setAadhaarLinkStatus] = useState("")
  const [dobFieldDisabled, setDobFieldDisabled] = useState(true);
  const [digiResponse, setdigiResponse] = useState(true);
  const [sourcePhone, setSourcePhone] = useState("");
  // const [aadhaarOtp, setAadhaarOtp] = useState("");
  const [leadType, setLeadType] = useState("");
  const [leadDropDownDisable, setLeadDropDownDisable] = useState(false);

  const leadOptions = [
    { label: "Borrower", value: "Borrower" },
    { label: "CoBorrower", value: "CoBorrower" },
  ];

  useEffect(() => {

    axios
      .post(url + "/user/getsingle", {
        email: email,
        token: token,
        useremail: email,
      })
      .then((res) => {
        if (res.data.logout === true) {
          toast.error(res.data.message);
          setTimeout(() => {
            navigate("/");
          }, 3000);
        }
        else {
          fetchconnectorData(res.data[0].staff_id) 
          setSource(res.data[0].staff_id);
          setSourcePhone(res.data[0].staff_mobile)
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.message);
      });

    if (email === "rupesh.bishnoi@credin.in") {
      axios
        .post(url + "/company/dropdownarray", {
          token: token,
          email: email,
        })
        .then((res) => {
          // // console.log(res);
          if (res.data.auth === false) {
            // // console.log("not found");
          } else {
            // // console.log(res);
            setData(res.data);
          }
        })
        .catch((err) => {
          // // console.log(err);
        });
    }
    const fetchconnectorData = async (staff_id) => {
      let headers = {
        token: token,
        email: email,
      }
      let connectorData = await axios.get(`${url}/connector/get/${staff_id}`,{
        headers: headers
      })
      console.log(connectorData.data.data)
      setConnectorData(connectorData.data.data)
    }
  }, [token, email, navigate]);

  useEffect(() => {
  const script = document.createElement("script");
  script.src = "https://app.digio.in/sdk/v11/digio.js"; // prod
  // script.src = "https://ext-gateway.digio.in/sdk/v11/digio.js"; // stag
  script.async = true;
  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  };
}, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (otpVerification === true) {
      console.log(aadhaarValidation);
      if (!leadType) return toast.error('Lead type is mandatory');
      if (voterId.length < 6) return toast.error('Invalid VoterID');
      if (leadType === 'Borrower' && panValidation !== 'VALID') return toast.error('Please verify PAN');
      // if (aadhaarValidation !== 'VALID' && aadhaarValidation !== 'N/A') return toast.error('Please verify AADHAAR');
      if (aadhaarNo.length !== 12) return toast.error('Invalid aadhaar')
      if (!isValidVoterId(voterId)) {
        return toast.error('Incorrect VoterId');
      }
      var reqArray = {
        token: token,
        email: email,
        lead_firstname: firstName?.toUpperCase(),
        lead_middlename: middleName?.toUpperCase(),
        lead_lastname: lastName?.toUpperCase(),
        lead_mobile: phoneNumber,
        lead_email: leadEmail,
        // lead_pan: pan,
        lead_pan: panNo,
        pandump: panDump,
        lead_dob: dateOfBirth,
        lead_source: source,
        borrowerOtp: borrowerOtp,
        // lead_aadhaar_no: aadhaar,
        aadhaardump: aadhaarDump,
        lead_aadhaar_no: aadhaarNo,
        lead_voter_no: voterId,
        lead_connector: connector,
        lead_aadhaarMobile_link: aadhaarLinkStatus,
        digiResponse: digiResponse,
        lead_type: leadType,

      };
      if (email === "rupesh.bishnoi@credin.in") {
        reqArray.lead_companycode = companyIdSuperadmin;
        reqArray.lead_branchcode = branchIdSuperadmin;
      }
      setOpen(true);
      axios
        .post(url + "/lead/add/v2", reqArray)
        .then((res) => {
          if (res.data.auth === true) {
            setOpen(false);
            toast.success("Lead Added");
            setTimeout(() => {
              navigate("/lead/view");
            }, 2000);
          } else if (res.data.auth === false) {
            setOpen(false);
            toast.error(res.data.message);
          } else {
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
      // })
      // .catch((err) => {
      //   // console.log(err);
      // });
    } else {
      toast.error("Please verify OTP before submitting");
      return;
    }
  };

  const handleDate = (event) => {
    const dateOfBirth = event.target.value;
    const currentDate = new Date();
    const inputDate = new Date(dateOfBirth);
    const ageDifferenceInMilliseconds = currentDate - inputDate;
    const ageInYears =
      ageDifferenceInMilliseconds / (365 * 24 * 60 * 60 * 1000);
    // console.log(ageInYears);

    if (ageInYears < 18) {
      toast.error("You must be at least 18 years old.");
      setDateOfBirth("");
      return;
    } else {
      setDateOfBirth(dateOfBirth);
    }
  };

  const handleChangePhoneNumber = (e) => {
    // if (firstName.trim() === "") {
    //   toast.error("First Name Cannot Start with Empty Space");
    //   return;
    // }
    // if (lastName.trim() === "") {
    //   toast.error("Last Name Cannot Start with Empty Space");
    //   return;
    // }
    if (e.target.value.length <= 10) {
      setPhoneNumber(e.target.value);
    }
    if (e.target.value.length === 10) {
      setTimeout(() => {
        let text = "Send OTP on " + e.target.value + "?";
        if (window.confirm(text) === true) {
          setOtpVerification(true);
          handleOtp(e.target.value);
        } else {
          toast.error("Please confirm your number for OTP Verification");
          // setOtpVerification(false);
          return;
        }
      }, 1000);
    }
  };

  const handleOtp = (phone) => {
    setOpen(true);
    axios
      .post(url + "/user/lms/otp/send", {
        templateId: "6352612bd6fc0569c5696062",
        email: email,
        token: token,
        borrowerMobile: phone,
        VAR1: firstName,
      })
      .then((res) => {
        setOpen(false);
        toast.success("OTP Sent to +91 " + phone);
        setTimeout(() => {
          const otp = prompt("Please Enter OTP received at +91 " + phone);
          // setOtp(d);
          handleVerify(otp, phone);
          setBorrowerOtp(otp)
        }, 4000);
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err.message);
      });
  };

  const handleVerify = (otp, phone) => {
    axios
      .post(url + "/user/lms/otp/verify", {
        borrowerOtp: otp,
        borrowerMobile: phone,
        email: email,
        token: token,
      })
      .then((res) => {
        if (res.data.type === "success") {
          // console.log(res.data);
          toast.success("OTP Verification Successful");
          setOtpVerification(true);
        } else {
          toast.error("Invalid OTP Please Try Again");
          return;
        }
      })
      .catch((err) => {
        // console.log(err);
        toast.error(err);
      });
  };

  const handleCompanyId = (event) => {
    setCompanyIdSuperadmin(event.target.value);
    setBranchIdSuperadmin("");
    // console.log(event.target.value);
    axios
      .post(url + "/branch/companytobranch", {
        company_id: event.target.value,
        token: token,
        email: email,
      })
      .then((res) => {
        if (res.data.auth === false) {
          // toast.dismiss("custom");
          // toast.error(res.data.message);
          // navigate("/");
        } else {
          // console.log(res.data);
          // toast.dismiss("custom");
          // toast.success("Loans Fetched Successfully");
          setData2(res.data.message);
          // console.log(res.data.message[0].branch_id);
        }
      })
      .catch((err) => {
        // console.log(err);
        // toast.dismiss("custom");
        // toast.error(err.message);
      });
  };

  // const handlefirstName = (e) => {
  //   var reg = /^([a-zA-Z\s]{0,100})$/;
  //   // console.log(e.target.value);
  //   if (reg.test(e.target.value)) {
  //     setFirstName(e.target.value);
  //   }
  // };

  // const handlemiddleName = (e) => {
  //   var reg = /^([a-zA-Z\s]{0,100})$/;
  //   // console.log(e.target.value);
  //   if (reg.test(e.target.value)) {
  //     setMiddleName(e.target.value);
  //   }
  // };

  // const handlelastName = (e) => {
  //   var reg = /^([a-zA-Z\s]{0,100})$/;
  //   // console.log(e.target.value);
  //   if (reg.test(e.target.value)) {
  //     setLastName(e.target.value);
  //   }
  // };

  const handlePANnew = (e) => {
    setPanNo(e.target.value);
  }

  const handlePANverify = async () => {
    console.log(panNo);
    if (!panNo) return toast.error('PAN can not be empty');
    if(panNo.length !== 10) return toast.error('Invalid PAN number..');

    setOpen(true);
    try {

      const checkPan = await axios.post(url + `/lead/verifyPan`, {
        lead_pan: panNo,
        token: token,
        email: email,
      })

      console.log(checkPan.data);
      if (checkPan.data.auth === 'duplicate') {
        toast.error(checkPan?.data?.message);
        setOpen(false);
        return;
      }

      if (!checkPan.data.auth) {
        setPanValidation("INVALID");
        toast.error(checkPan?.data?.message);
        setOpen(false);
        return;
      }

      if (checkPan.data.auth) {
        setPanValidation("VALID");
        setFirstName(checkPan?.data?.first);
        setMiddleName(checkPan?.data?.middle);
        setLastName(checkPan?.data?.last);
        setPanDump(checkPan?.data?.message);
        if (checkPan?.data.message.date_of_birth != null) {
          setDateOfBirth(convertDateFormat(checkPan?.data.message.date_of_birth));
        } else {
          setDobFieldDisabled(false);
        }
        // setPanAadhaarLink(checkPan?.data?.message?.data?.aadhaar_seeding_status);
        // setPanAadhaarLink(checkPan?.data?.message?.data?.aadhaar_seeding_status ? checkPan.data.message.data.aadhaar_seeding_status.toLowerCase() === 'y' ? 'YES' : checkPan.data.message.data.aadhaar_seeding_status : undefined);
        setPanAadhaarLink(checkPan?.data?.message?.aadhaar_linked ? checkPan.data.message.aadhaar_linked === true ? 'YES' : checkPan.data.message.aadhaar_linked : undefined);
        setOpen(false);
        return;
      }
    } catch (err) {
      console.log(err);
      setOpen(false);
      return;
    }
  }

  const handleAADHAARnew = (e) => {
    setAadhaarNo(e.target.value);
  }

  /*
  const handleAADHAARverify = async () => {
    console.log(aadhaarNo);
    if (!aadhaarNo) return toast.error('Aadhaar can not be empty');
    if (aadhaarNo.length !== 12) return toast.error('Invalid Aadhaar number..');

    setOpen(true);
    axios
      .post(url + `/lead/verifyAadhaar/sendOtp`, {
        email: email,
        token: token,
        aadhaarNo: aadhaarNo
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.auth === 1) {
          setAadhaarLinkStatus(res.data?.message?.message);
          setAadhaarValidation('N/A');
          setAadhaarDump(res.data.message);
          // setDobFieldDisabled(false);
          setOpen(false);
        } else if (res.data.auth === true) {
          setOpen(false);
          toast.success("OTP Sent to registered mobile number");
          setTimeout(() => {
            const otp = prompt("Please Enter OTP");
            handleVerifyAadhaarOtp(otp, res.data.ref_id);
            // setAadhaarOtp(otp)
          }, 4000);
        } else {
          setOpen(false);
          toast.error(res.data.message);
          return;
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err.message);
        return;
      });
  }

  const handleVerifyAadhaarOtp = (otp, refId) => {
    console.log(otp, refId);
    setOpen(true);
    axios
      .post(url + "/lead/verifyAadhaar/verifyOtp", {
        otp: otp,
        refId: refId,
        email: email,
        token: token,
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.auth) {
          let dob = res.data.message.dob;
          let age = calculateAge(dob);
          if (age < 18) {
            toast.error('Age should be more than 18');
            setOpen(false);
            return;
          }
          if (res.data.message?.mobile_hash) {
            setAadhaarLinkStatus("Mobile Linked");
          } else {
            setAadhaarLinkStatus("N/A");
          }
          setAadhaarValidation("VALID");
          setAadhaarDump(res.data.message);
          // setDateOfBirth(convertDateFormat(res.data.message.dob));
          toast.success("OTP Verification Successful");
          setOpen(false);
        } else {
          toast.error("Invalid OTP Please Try Again");
          setOpen(false);
          return;
        }
      })
      .catch((err) => {
        // console.log(err);
        toast.error(err);
        setOpen(false);
        return;
      });
  }  

  const calculateAge = (dob) => {
    const formattedDOB = convertDateFormat(dob);
    const birthDate = new Date(formattedDOB);

    const ageDifMs = Date.now() - birthDate.getTime();
    const ageDate = new Date(ageDifMs);

    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };
  */

  const convertDateFormat = (dob) => {
    const [day, month, year] = dob.split("-");
    return `${year}-${month}-${day}`;
  };

  const isValidVoterId = (voterId) => {
    console.log(voterId);
    const alphanumericPattern = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]*$/;
    console.log(alphanumericPattern.test(voterId));
    return alphanumericPattern.test(voterId);
  };

  const handleDigioSign = async () => {
    if (!window.Digio) {
      alert("Digio SDK is not loaded yet.");
      return;
    }

    const fetchID = await axios.post(url + `/borrower/getID`, {
      phone: sourcePhone
    });
    console.log(fetchID.data);

    if (fetchID.data.auth !== true) {
      alert('Please try again');
      return;
    }
    setdigiResponse(fetchID.data.message);
    
    const options = {
      environment: "production",
      // environment: "sandbox",

      callback: async function (response) {
        if (response?.error_code) {
          console.error("Digio Error:", response.message);
          toast.error('Aadhaar authentication failed');
        } else {
          console.log("Digio Success:", response);

          const fetchData = await axios.post(url + `/borrower/getDigiAadhaar`, {
            id: response.digio_doc_id
          });

          console.log(fetchData.data);
          if (fetchData.data.auth === true) {
            console.log(fetchData.data.message);
            setAadhaarDump(fetchData.data.message);
            setAadhaarValidation("VALID");
            setAadhaarLinkStatus("Mobile Linked");
            toast.success('Aadhaar verified');
            setLeadDropDownDisable(true);
          } else {
            toast.error('Aadhaar Details not fetched');
          }
        }
      },

      event_listener: function (event) {
        console.log("Digio Event:", event);

        if (event?.payload?.data) {
          const kycData = event.payload.data;
          console.log("KYC Data:", kycData);          
        }

        if (event?.payload?.error) {
          console.error("Digio Error Event:", event.payload.error);
        }
      },

      // logo: "https://yourcompany.com/logo.png", // Optional
      theme: {
        primaryColor: "#0055FF",
        secondaryColor: "#000000",
      },
    };

    const digio = new window.Digio(options);
    digio.init();
    digio.submit(fetchID.data.message.id, fetchID.data.message.customer_identifier);
  };

  return (
    // <div className="background-add-lead">
    //   <div className="container-add-lead">
    //     {/* <div className="image-add-lead">
    //       <img src={Logo} alt="" style={{ paddingBottom: "1.5rem" }} />
    //     </div> */}

    //     <div className="addLead-add-lead">
    //       <p className="heading-add-lead">
    //         <strong>Add Lead</strong>
    //       </p>
    //       <Link to="/lead/view" style={{ textDecoration: "none" }}>
    //         <button className="btn1">
    //           <ArrowBackIcon sx={{ marginRight: ".1rem" }} /> Back
    //         </button>
    //       </Link>
    //     </div>
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"AddLead"} />
      <div style={{ marginLeft: isOpen ? "18%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h3 className="main-heading">
              <AiOutlineTable />
              Add Lead
            </h3>
            <div className="inputsField-add">
              <form className="add-lead-form" action="" onSubmit={handleSubmit}>

                <div className="form-add-lead">
                  <div className="input-div">
                    <label className="form-label">Create Lead For:</label>

                    <select
                      className="dropdown"
                      value={leadType}
                      onChange={(e) => setLeadType(e.target.value)}
                      disabled={leadDropDownDisable}
                    >
                      <option value="" disabled>
                        Select Lead Type
                      </option>

                      {leadOptions.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="input-div">
                    <label>Mobile Number*</label>
                    <TextField
                      name="phoneNumber"
                      placeholder="Phone Number"
                      type="number"
                      size="small"
                      onChange={handleChangePhoneNumber}
                      value={phoneNumber}
                      required
                      disabled={otpVerification}
                      helperText="Verify OTP Before Submitting*"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: ".6rem",
                        },
                      }}
                    />
                  </div>

                  <div className="input-div">
                    <label>Email*</label>
                    <TextField
                      name="email"
                      placeholder="Email ID"
                      size="small"
                      required
                      onChange={(e) => setLeadEmail(e.target.value)}
                      value={leadEmail}
                      type="email"
                    />
                  </div>

                </div>

                <div className="form-add-lead">
                  <div className="input-div">
                    <label>PAN NUMBER*</label>
                    <TextField
                      name="panNumber"
                      placeholder="PAN Number"
                      size="small"
                      onChange={(e) => handlePANnew(e)}
                      value={panNo}
                      // required
                      disabled={panValidation === 'VALID'}
                    />
                  </div>

                  <div className="button-container">
                    <Button variant="contained" onClick={handlePANverify} style={{}}>Verify</Button>
                    <label style={{ marginLeft: "15px" }}>Status: </label>
                    <span style={{ marginLeft: "5px", fontWeight: "bold" }}>{panValidation}</span>
                  </div>

                  <div className="button-container">
                    <label>PAN-Aadhaar Link Status :</label>
                    <span style={{ marginLeft: "5px", fontWeight: "bold" }}>{panAadhaarLink}</span>
                  </div>

                </div>

                <div className="form-add-lead">
                  <div className="input-div">
                    <label>First Name*</label>
                    <TextField
                      name="firstName"
                      placeholder="First Name"
                      size="small"
                      // onChange={(e) => handlefirstName(e)}
                      value={firstName}
                      required
                      disabled
                    />
                  </div>
                  <div className="input-div">
                    <label>Middle Name</label>
                    <TextField
                      name="middleName"
                      placeholder="Middle Name"
                      size="small"
                      // required
                      // onChange={(e) => handlemiddleName(e)}
                      value={middleName}
                      disabled
                    />
                  </div>
                  <div className="input-div">
                    <label>Last Name*</label>
                    <TextField
                      name="lastName"
                      placeholder="Last Name"
                      size="small"
                      // onChange={(e) => handlelastName(e)}
                      value={lastName}
                      required
                      disabled
                    />
                  </div>
                </div>

                <div className="form-add-lead">
                  <div className="input-div">
                    <label>AADHAAR NUMBER*</label>
                    <TextField
                      name="aadhaarNumber"
                      placeholder="AADHAAR Number"
                      size="small"
                      onChange={(e) => handleAADHAARnew(e)}
                      value={aadhaarNo}
                      required
                      disabled={aadhaarValidation === 'VALID'}
                    />
                  </div>

                  <div className="button-container">
                    {/*<Button variant="contained" onClick={handleAADHAARverify} style={{}}>Verify</Button>*/}
                    <Button variant="contained" onClick={handleDigioSign} style={{}}>Verify</Button>
                    <label style={{marginLeft: "15px"}}>Status: </label>
                    <span style={{marginLeft: "5px", fontWeight: "bold"}}>{aadhaarValidation}</span>
                  </div>

                  <div className="button-container">
                    <label>Aadhaar-Mobile Link Status :</label>
                    <span style={{marginLeft: "5px", fontWeight: "bold"}}>{aadhaarLinkStatus}</span>
                  </div>

                  {/* <Button variant="contained" onClick={handleDigioSign}>
                    Start DIGILOCKER
                  </Button> */}

                </div>              

                <div className="form-add-lead">
                  {/* <div className="input-div">
                    <label>First Name*</label>
                    <TextField
                      name="firstName"
                      placeholder="First Name"
                      size="small"
                      onChange={(e) => handlefirstName(e)}
                      value={firstName}
                      required
                    />
                  </div> */}
                  {/* <div className="input-div">
                    <label>Middle Name</label>
                    <TextField
                      name="middleName"
                      placeholder="Middle Name"
                      size="small"
                      // required
                      onChange={(e) => handlemiddleName(e)}
                      value={middleName}
                    />
                  </div> */}
                  {/* <div className="input-div">
                    <label>Last Name*</label>
                    <TextField
                      name="lastName"
                      placeholder="Last Name"
                      size="small"
                      onChange={(e) => handlelastName(e)}
                      value={lastName}
                      required
                    />
                  </div> */}


                  <div className="input-div">
                    <label>Date of Birth*</label>
                    <TextField
                      name="dob"
                      required
                      size="small"
                      type="date"
                      onChange={handleDate}
                      disabled = {dobFieldDisabled}
                      value={dateOfBirth}
                      // label="Date of Birth"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                    />
                  </div>

                  
                  
                  {/* <div className="input-div">
                    <label>PAN Number*</label>
                    <TextField
                      name="pan"
                      onChange={(e) => setPan(e.target.value)}
                      value={pan}
                      size="small"
                      required
                      placeholder="PAN Number"
                    />
                  </div> */}
                  {/* <div className="input-div">
                    <label>Aadhaar Number*</label>
                    <TextField
                      name="aadhaar"
                      onChange={(e) => setAadhaar(e.target.value)}
                      value={aadhaar}
                      size="small"
                      required
                      placeholder="Aadhaar Number"
                    />
                  </div> */}
                  <div className="input-div">
                    <label>Voter Id*</label>
                    <TextField
                      name="voterid"
                      onChange={(e) => setVoterId(e.target.value)}
                      value={voterId}
                      size="small"
                      required
                      placeholder="Voter Id"
                    />
                  </div>
                  {/* <div className="input-div">
                    <label>Date of Birth*</label>
                    <TextField
                      name="dob"
                      required
                      size="small"
                      type="date"
                      onChange={handleDate}
                      value={dateOfBirth}
                      // label="Date of Birth"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div> */}
                  <div className="input-div">
                    <label>Connector*</label>
                    <TextField
                      name="connector-id"
                      required
                      select
                      size="small"
                      onChange={(e)=>setconnector(e.target.value)}
                      value={connector}
                    >
                      {connectorData.map((data) => (
                        <MenuItem key={data._id} value={data.connectorId}>
                          {data.connectorName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>

                  {email === "rupesh.bishnoi@credin.in" ? (
                    <>
                      <div className="input-div">
                        <label>Company Id*</label>
                        <TextField
                          name="company-id"
                          required
                          select
                          size="small"
                          onChange={handleCompanyId}
                          value={companyIdSuperadmin}
                        // label="Date of Birth"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        >
                          {data.map((data, id) => (
                            <MenuItem key={id} value={data.company_id} disabled={!data.is_active}>
                              {data.company_id + " " + data.company_name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label>Branch Id*</label>
                        <TextField
                          name="branch-id"
                          required
                          select
                          size="small"
                          onChange={(e) =>
                            setBranchIdSuperadmin(e.target.value)
                          }
                          value={branchIdSuperadmin}
                        // label="Date of Birth"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        >
                          {data2.map((data, id) => (
                            <MenuItem key={id} value={data.branch_id} disabled={!data.is_active}>
                              {data.branch_id + " " + data.branch_name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className="submitBtn-add-lead">
                  <button type="submit" className="btn2">
                    Submit
                  </button>
                </div> */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: "1.5rem 0",
                  }}
                >
                  <Button type="submit" variant="contained">
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
        
        <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
}